// extracted by mini-css-extract-plugin
export default {"warning":"CloseAccountModal_warning__m3h9E","background":"CloseAccountModal_background__Mp9MR"};